import { render, staticRenderFns } from "./IccDownloadsStatistics.vue?vue&type=template&id=35bc1060&scoped=true&"
import script from "./IccDownloadsStatistics.vue?vue&type=script&lang=js&"
export * from "./IccDownloadsStatistics.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/statistics.styl?vue&type=style&index=0&id=35bc1060&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bc1060",
  null
  
)

export default component.exports